import React from 'react';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = ({ t }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8 px-4">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_job-albania-de/artifacts/d1x1sky4_e4cb23c6-1b36-435e-bad7-f845dd3a306e.jpg" 
                alt="ATG - Majestic Workforce" 
                className="h-24 w-auto object-contain mb-4"
              />
              <div className="mt-3">
                <div className="font-bold text-2xl text-white mb-1">Majestic Workforce</div>
                <div className="text-yellow-500 font-semibold">Albania to Europe Employment Agency</div>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed">
              Professional work agency connecting Albanian talent with German opportunities.
            </p>
            <div className="flex gap-3 pt-4">
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">{t.footer.quickLinks}</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-slate-400 hover:text-emerald-400 transition-colors">
                  {t.nav.home}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-slate-400 hover:text-emerald-400 transition-colors">
                  {t.nav.about}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-slate-400 hover:text-emerald-400 transition-colors">
                  {t.nav.services}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('jobs')} className="text-slate-400 hover:text-emerald-400 transition-colors">
                  {t.nav.jobs}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-slate-400 hover:text-emerald-400 transition-colors">
                  {t.nav.testimonials}
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">{t.nav.services}</h3>
            <ul className="space-y-3 text-slate-400">
              <li>Job Matching</li>
              <li>Visa Assistance</li>
              <li>Relocation Support</li>
              <li>Language Training</li>
              <li>Legal Support</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">{t.footer.contactInfo}</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-1" />
                <span className="text-slate-400">Rr. Sami Frasheri, Sheshi Willson, Tirana, Albania</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-1" />
                <div className="text-slate-400">
                  <div>00355 694 342 666</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} Majestic Workforce - ATG. {t.footer.rights}
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
